// extracted by mini-css-extract-plugin
export default {"buttonLink":"linkPersonalizado9_buttonLink__BeNqB"};